import { gql, useMutation } from '@apollo/client';

import { GET_EMAIL_TEMPLATES } from './get-email-templates.hook';

export const CREATE_EMAIL_TEMPLATE = gql`
  mutation createEmailTemplate($payload: CreateEmailTemplateInput!) {
    createEmailTemplate(payload: $payload) {
      _id
    }
  }
`;

export const useCreateEmailTemplate = ({ onSuccess }: { onSuccess?: () => void }) => {
  const [createEmailTemplate] = useMutation(CREATE_EMAIL_TEMPLATE, {
    refetchQueries: [GET_EMAIL_TEMPLATES],
    onCompleted: () => {
      if (onSuccess) {
        onSuccess();
      }
    },
  });

  return createEmailTemplate;
};
